import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ltcs-missing-request__msg"
}

import { computed, ref } from 'vue';
import LtcsHrRequestModal from '@/components/member/request/LtcsHrRequestModal.vue';
import { isLtcsMacroBizGubun } from '@/constants/ltcsMacro';


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsMissingRequestCta',
  props: {
    memberCode: {},
    bizGubun: { default: '' },
    yearMonth: {},
    types: {},
    message: { default: '' },
    buttonLabel: { default: '롱텀케어에서 가져오기' },
    compact: { type: Boolean, default: false }
  },
  emits: ["updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showModal = ref(false);

const memberCode = computed(() => String(props.memberCode || ''));

const canRequest = computed(
  () => !!memberCode.value && isLtcsMacroBizGubun(props.bizGubun)
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (canRequest.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ltcs-missing-request", { 'ltcs-missing-request--compact': __props.compact }])
      }, [
        (__props.message)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.message), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "ltcs-missing-request__btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
        }, [
          _createVNode(_component_v_icon, { size: "14" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-cloud-download-outline", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(__props.buttonLabel), 1)
        ]),
        _createVNode(LtcsHrRequestModal, {
          modelValue: showModal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
          "member-code": memberCode.value,
          "biz-gubun": __props.bizGubun,
          "year-month": __props.yearMonth,
          "allowed-types": __props.types,
          onUpdated: _cache[2] || (_cache[2] = ($event: any) => (emit('updated')))
        }, null, 8, ["modelValue", "member-code", "biz-gubun", "year-month", "allowed-types"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})